const MAX_TOOLTIP_ID = 15;

const mapToolTips = (id, translate) => {
  if (typeof id !== "number" || id < 1 || id > MAX_TOOLTIP_ID) return "";
  return translate(`benchmarking.survey.company-overhead.accordion.tooltip.${id}`);
};

// ───────────────────────────────────────────────────────────────────────────────
// OUTBOUND (UI -> API)
// ───────────────────────────────────────────────────────────────────────────────
export const toOverheadsDTO = (companyInputId, overheads) => {
  const accounts = [];
  overheads.forEach((parent) => {
    accounts.push({ accountId: parent.id, amount: parent.amount });
    parent.content.forEach((child) => {
      accounts.push({ accountId: child.id, amount: child.amount });
    });
  });
  return {
    companyInputId,
    lastUpdated: new Date().toISOString(),
    accounts,
  };
};

// ───────────────────────────────────────────────────────────────────────────────
// INBOUND (API -> UI)
// ───────────────────────────────────────────────────────────────────────────────
export const fromOverheadsDTO = (overheads = [], translate) =>
  (Array.isArray(overheads) ? overheads : []).map((overhead) => {
    const children = Array.isArray(overhead?.children) ? overhead.children : [];

    const content = children.map((child) => ({
      accountId: child?.account?.id,
      amount: child?.amount,
      code: child?.account?.code,
      id: child?.account?.id,
      label: child?.account?.name,
      lastUpdated: child?.lastUpdated,
      parentAccountId: child?.account?.parentAccountId,
    }));

    return {
      id: overhead?.accountId,
      accountId: overhead?.accountId,
      title: overhead?.account?.name,
      tooltip: mapToolTips(overhead?.account?.id, translate),
      amount: overhead?.amount,
      content,
      errors: [],
    };
  });
